import axios from 'axios';
import { API_DOMAIN } from '../utils/constants';

export const registerWhatsappAccount = async (payload) => {
  return await axios.post(`${API_DOMAIN}/whatsapp/register`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};
